import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/erQjqjpTF7dwMEu8oFtrNg/heylloyd-image-1785289119088.png',
  alt: 'Pantalla de inicio de la app Vuelve a Vivir'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/v8FAPputSfdsbHfZbKxQdH/WhatsApp_Image_2026-09-09_at_4.46.51_PM.jpg',
  alt: 'Pantalla de bienvenida de la app con la explicación del Método del 1%'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8yiNkxtsj61bN5wr8dgGU6/WhatsApp_Image_2026-09-09_at_4.46.52_PM.jpg',
  alt: 'Pantalla Mi Programa con los días del reto de 30 días'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rTv8w4iWxB2JXJcnbRRN2b/WhatsApp_Image_2026-09-09_at_4.46.52_PM_(1).jpg',
  alt: 'Pantalla Biblioteca con recetarios, guías y protocolos de la app'
}];
export function AppCarousel() {
  const [index, setIndex] = React.useState(0);
  const reduceMotion = useReducedMotion();
  React.useEffect(() => {
    const id = window.setInterval(() => {
      setIndex(current => (current + 1) % slides.length);
    }, 3500);
    return () => window.clearInterval(id);
  }, []);
  return <div className="relative" data-id="element-1" data-mp="3oqrijl7apzmo">
      <div className="relative mx-auto aspect-[9/19] w-full overflow-hidden rounded-[2rem] bg-crema p-2 shadow-2xl shadow-rosa/20 ring-1 ring-white/60" aria-roledescription="carrusel" aria-label="Pantallas de la app Vuelve a Vivir" data-id="element-2" data-mp="3opq9fm9ubn7l">
        <AnimatePresence initial={false} mode="sync" data-id="element-3" data-mp="3aqyxo6igadmm">
          <motion.img key={slides[index].src} src={slides[index].src} alt={slides[index].alt} className="absolute inset-2 mx-auto h-[calc(100%-1rem)] w-auto max-w-[calc(100%-1rem)] rounded-[1.5rem] object-contain" initial={reduceMotion ? {
          opacity: 1
        } : {
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={reduceMotion ? {
          opacity: 1
        } : {
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-4" data-mp="3atl4g3xiop3s" />
        </AnimatePresence>
      </div>

      <div className="mt-4 flex items-center justify-center gap-2" data-id="element-5" data-mp="2y960067vor21">
        {slides.map((slide, i) => <button key={slide.src} type="button" onClick={() => setIndex(i)} aria-label={`Ver pantalla ${i + 1} de ${slides.length}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 ${i === index ? 'w-6 bg-rosa' : 'w-2 bg-rosa/30 hover:bg-rosa/50'}`} data-id="element-6" data-mp="2kij38jlohb8l" data-mpi={i} />)}
      </div>
    </div>;
}